import * as React from 'react';

import { IItemsType, ICurrency, IJRWTicketOrderItem } from './types';
import { calculateJRWItemPrice } from './helpers';
import t from './locales';

import OrderItemView from './OrderItemView';
import OrderItemPriceView from './OrderItemPriceView';
import OrderItemNumberSelect from './OrderItemNumberSelect';
import Price from '../Shared/Price';
import { getLocale } from '../utils/pathHelper';

interface IOrderItemProps {
  item: IJRWTicketOrderItem;
  itemsType: IItemsType;
  handleChange: (event: React.ChangeEvent) => void;
  handleRemove: (evnet: React.MouseEvent) => void;
  index: number;
  localCurrency?: ICurrency;
}

const JRWTicketOrderItem: React.FC<IOrderItemProps> = ({
  item,
  itemsType,
  handleChange,
  handleRemove,
  index,
  localCurrency,
}) => {
  const { name, plan, numPassengers } = item;
  const itemPrice = calculateJRWItemPrice(
    plan.adultSellingPrice,
    numPassengers
  );
  const locale: string = getLocale() || 'en';
  const maxParticipants = 10;
  return (
    <OrderItemView key={`ticket-order-item-${index}`}>
      <div>
        <p className="name">
          <span>{name}</span>
          <span style={{marginLeft: '6px', marginRight: '6px'}}> </span>
          <span>{plan.name}</span>
        </p>
        <div className="number-select">
          {/* TODO 最初はadultのみ */}
          {plan.adultSellingPrice && (
            <div>
              <p>{t.adultNum()}</p>
              <OrderItemNumberSelect
                selectedNumber={numPassengers}
                handleChange={handleChange}
                itemsType={itemsType}
                propKey="adultNum"
                index={index}
                max={maxParticipants}
              />
            </div>
          )}
        </div>
      </div>
      <OrderItemPriceView>
        <div className='item-price'>
          <Price
            price={itemPrice}
            fontSize={14}
            localCurrency={localCurrency}
          />
          {locale !='ja' &&
            <a
              href="#"
              onClick={handleRemove}
              data-index={index}
              data-items-type={itemsType}
              className="trash"
            >
              <i className="fas fa-trash" />
            </a>
          }
        </div>

        {locale =='ja' &&
          <a href="#" onClick={handleRemove} data-index={index} data-items-type={itemsType} className="remove-item">
            <i className="fas fa-trash" />
            カートから削除
          </a>
        }
      </OrderItemPriceView>
    </OrderItemView>
  );
};

export default JRWTicketOrderItem;
